import React from 'react'
import {Icon} from '@chakra-ui/react'

const FeedbackSuccessIcon = (props) => {
    return (
        <Icon viewBox="0 0 20 20" fill="none" {...props}>
            <path
                d="M9.99966 2.16669C14.3257 2.16669 17.8335 5.67361 17.8336 9.99969C17.8336 14.3259 14.3259 17.8337 9.99966 17.8337C5.67358 17.8335 2.16666 14.3258 2.16666 9.99969C2.16683 5.67372 5.67369 2.16686 9.99966 2.16669ZM13.2126 7.04559C12.7317 6.65223 12.023 6.72392 11.6295 7.20477L8.66666 10.8259L7.87857 10.0378C7.43922 9.59861 6.72703 9.59851 6.28775 10.0378C5.84847 10.4771 5.84857 11.1892 6.28775 11.6286L7.95474 13.2956C8.17958 13.5204 8.48912 13.6395 8.8063 13.6237C9.1236 13.6078 9.41952 13.4585 9.62076 13.2126L13.3708 8.6286C13.764 8.14768 13.6933 7.43892 13.2126 7.04559Z"
                fill="currentColor"
                stroke="currentColor"
            />
        </Icon>
    )
}

export default FeedbackSuccessIcon
